"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kebabToCamel = kebabToCamel;
exports.regularToCamel = regularToCamel;
exports.regularToPascal = regularToPascal;
exports.removeAccents = removeAccents;
exports.modelScripts = modelScripts;
function kebabToCamel(s) {
    var _a;
    try {
        if (typeof s !== "string")
            throw new Error("Wrong type argumented to kebabToCamel");
        return /[_\-]/g.test(s)
            ? "".concat(s.replace(/[-_]([a-z])/gi, function (_, c) { return c.toUpperCase(); }))
            : s;
    }
    catch (e) {
        console.error("Error executing kebabToCamel:\n".concat(e.message));
        return (_a = s.toString()) !== null && _a !== void 0 ? _a : "";
    }
}
function regularToCamel(s) {
    var _a;
    try {
        if (typeof s !== "string")
            throw new Error("Wrong type argument to regularToCamel");
        return /\s/g.test(s)
            ? s
                .split(" ")
                .map(function (f, i) {
                return i === 0
                    ? f.toLowerCase()
                    : "".concat(f.charAt(0).toUpperCase()).concat(f.slice(1));
            })
                .join("")
            : s.toLowerCase();
    }
    catch (e) {
        console.error("Error executing regularToCamel:\n".concat(e.message));
        return (_a = s.toString()) !== null && _a !== void 0 ? _a : "";
    }
}
function regularToPascal(s) {
    var _a;
    try {
        if (typeof s !== "string")
            throw new Error("Wrong type argument to regularToPascal");
        return /\s/g.test(s)
            ? s
                .split(" ")
                .map(function (f) { return "".concat(f.charAt(0).toUpperCase()).concat(f.slice(1)); })
                .join("")
            : s.toLowerCase();
    }
    catch (e) {
        console.error("Error executing regularToPascal:\n".concat(e.message));
        return (_a = s.toString()) !== null && _a !== void 0 ? _a : "";
    }
}
function removeAccents(s) {
    try {
        if (typeof s !== "string")
            throw new Error("Wrong type argumented to removeAccents");
        if (s.length === 0)
            return s;
        return s
            .replace(/[\u00C0-\u00C6]/g, "A")
            .replace(/[\u00E0-\u00E6]/g, "a")
            .replace(/[\u00C7]/g, "C")
            .replace(/[\u00E7]/g, "c")
            .replace(/[\u00C8-\u00CB]/g, "E")
            .replace(/[\u00E8-\u00EB]/g, "e")
            .replace(/[\u00CC-\u00CF]/g, "I")
            .replace(/[\u00EC-\u00EF]/g, "i")
            .replace(/[\u00D1]/g, "N")
            .replace(/[\u00F1]/g, "n")
            .replace(/[\u00D2-\u00D6]/g, "O")
            .replace(/[\u00F2-\u00F6]/g, "o")
            .replace(/[\u00D9-\u00DC]/g, "U")
            .replace(/[\u00F9-\u00FC]/g, "u")
            .replace(/[\u00DD]/g, "Y")
            .replace(/[\u00FD\u00FF]/g, "y");
    }
    catch (e) {
        console.error("Error executing removeAccents:\n".concat(e.message));
        return s;
    }
}
function modelScripts() {
    try {
        document.querySelectorAll("script").forEach(function (script, i) {
            try {
                if (!(script instanceof HTMLScriptElement))
                    return;
                if (script.type === "" && script.src !== "")
                    script.type = "text/javascript";
                if (script.id === "" && script.src !== "") {
                    var url = new URL(script.src);
                    script.id = url.pathname.replace(/[\-\?\=\+\s\.~,]/g, "__");
                }
                if (script.crossOrigin === "")
                    script.crossOrigin = "anonymous";
            }
            catch (e) {
                console.error("Error executing iteration ".concat(i, " for <script> tags in modelScripts:\n").concat(e.message));
            }
        });
        document.querySelectorAll("link").forEach(function (link, i) {
            try {
                if (!(link instanceof HTMLLinkElement))
                    return;
                if (link.id === "" && link.href !== "") {
                    var url = new URL(link.href);
                    link.id = url.pathname.replace(/[\-\?\=\+\s\.\&\<\>\^~,]/g, "__");
                }
                if (link.rel === "")
                    link.rel = "alternate";
                if (link.crossOrigin === "")
                    link.crossOrigin = "anonymous";
            }
            catch (e) {
                console.error("Error executing iteration ".concat(i, " for <link> tags in modelScripts:\n").concat(e.message));
            }
        });
        document.querySelectorAll("a").forEach(function (a, i) {
            try {
                if (!(a instanceof HTMLAnchorElement))
                    return;
                if (a.href !== "" &&
                    !(new RegExp(location.hostname, "g").test(a.href) ||
                        /https/.test(a.href))) {
                    if (!/noopener/g.test(a.rel))
                        a.rel += " noopener";
                    if (!/noreferrer/g.test(a.rel))
                        a.rel += " noreferrer";
                }
            }
            catch (e) {
                console.error("Error executing iteration ".concat(i, " for <a> tags in modelScripts:\n").concat(e.message));
            }
        });
    }
    catch (e) {
        console.error("Error executing modelScripts:\n".concat(e.message));
    }
}
